import { Timezone } from "@syncfusion/ej2-react-schedule";

export const convertToLocalTime = (timeToConvertString) => {
  var timezone = new Timezone()
  var timeToConvert = new Date(timeToConvertString);
  var localTimezone = timezone.getLocalTimezoneName();
  var fromOffset = timezone.offset(timeToConvert, 'America/Toronto');
  var toOffset = timezone.offset(timeToConvert, localTimezone);
  var newtime = timezone.convert(timeToConvert, fromOffset, toOffset);
  return newtime.toISOString();
};
